<template>
  <div>
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      :debounce-search="4"
      :readonly="select != null"
      no-filter
      hide-selected
      clearable
      return-object
      outlined
      chips
      :hide-details="hideDetails"
      hide-no-data
      dense
      label="Buscar empleado por NUE, Nombre o Correo Institucional (Presione ENTER para comenzar la búsqueda)"
      required
      @keyup.enter="querySearch()"
      @change="selectItem()"
    >
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="rgb(0, 45, 83)"
          class="white--text"
          v-on="on"
          small
        >         
          <v-avatar left>
              <v-img :src="`http://siidrh.ugto.mx/ws/APIPerfilBasico/Foto/${item.nue}/lg?a_resolucion=1&env=production`" small></v-img>
          </v-avatar>
          <span v-text="item.nue + ' - ' + item.nombre + ' (' + item.correo + ')'"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <img :src="`http://siidrh.ugto.mx/ws/APIPerfilBasico/Foto/${item.nue}/lg?a_resolucion=1&env=production`">
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title v-text="item.nue  + ' - ' + item.nombre + ' (' + item.correo + ')'"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>

    <v-snackbar
      key="snackbar_buscadorempleado"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash';
import { getBuscadorEmpleados } from "@/api";

export default {
  name: "BuscadorEmpleado",
  components: {
  },
  props: {
    fnSeleccionarEmpleado: {
      type: Function,
      required: true
    },
    banLimpiarDatos: {
      type: Number,
      default: 0
    },
    hideDetails: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      select: null,
      search: null,
      items: [],
      loading: false,

      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

    };
  },
  computed: {
  },
  watch:{
    banLimpiarDatos: {
      handler (newValue, oldValue) {
        this.select = null;
        this.items = [];
			},
    },
  },
  beforeMount(){
  },
  mounted() {
    
  },
  methods: {
    async querySearch(){
      if(this.search == null ? false : this.search != '' && this.search.length > 3){
        this.loading = true;
        this.items = [];

        try {
          let response = await getBuscadorEmpleados(this.search);

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Consulta correcta") {
                this.items = response.data.data
              }
            } else {
              console.log('BuscadorEmpleado: ' + response.data.message)
            }
          } else {
            console.log('BuscadorEmpleado:  Error de red');
          }
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      }
    },
    selectItem(){
      this.fnSeleccionarEmpleado(this.select)
    },
  },  
};
</script>